module.exports = __webpack_public_path__ + "img/Designlazy_macbook-mockup 1.8bbbd180.png";